import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { ErrorLogDetailDialogComponent } from './error-log-detail-dialog/error-log-detail-dialog.component';
import { ErrorLogsComponent } from './error-logs/error-logs.component';
import { ErrorLogsEffects } from './store/error-logs.effects';
import * as fromErrorLogs from './store/error-logs.reducers';

// NOTE: not used
// Included in wireframes but not included in final product at the moment

const errorLogsRoutes: Routes = [
    { path: Pages.errorLogs.path, component: ErrorLogsComponent },
    { path: '**', component: ErrorLogsComponent }
];

@NgModule({
    declarations: [ErrorLogsComponent, ErrorLogDetailDialogComponent],
    imports: [
        CommonModule,
        MaterialModule,
        LoadingModule,
        LocationContextPanelModule,
        NotificationsModule,
        RouterModule.forChild(errorLogsRoutes),
        StoreModule.forFeature(fromErrorLogs.errorLogsFeatureKey, fromErrorLogs.errorLogsContextReducer, {
            metaReducers: fromErrorLogs.metaReducers
        }),
        EffectsModule.forFeature([ErrorLogsEffects])
    ]
})
export class ErrorLogsModule {}
